import { render, staticRenderFns } from "./Circle5.vue?vue&type=template&id=12a715ad&scoped=true&"
import script from "./Circle5.vue?vue&type=script&lang=js&"
export * from "./Circle5.vue?vue&type=script&lang=js&"
import style0 from "./Circle5.vue?vue&type=style&index=0&id=12a715ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a715ad",
  null
  
)

export default component.exports